export default "__VITE_ASSET__44qo6EZO__"